import { Grid } from "@mui/material"

import CategoryCard from "./CategoryCard"
import { categories } from "../../app/models/categories"



export default function CategoryList() {

  
 
  return (
    <Grid container spacing={5} columnSpacing={1} justifyContent="center">
        {[...categories].sort().map(category => (
          <Grid item xs={12} sm={6} key={category}>
            <CategoryCard category={category} />
          </Grid> 
          
        ))}
    </Grid>
  )
}